import paths from '../paths';
import { ProfileKisaanClient } from './profileKisanClient';

export const getAllProfileActivity = async (payload: object) => {
  try {
    const response = await ProfileKisaanClient.get(paths.getProfileAllActivity(payload));
    return response.data;
  } catch (e) {
    console.error('Global Search Api Error', e);
    throw e;
  }
};
